import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-custom-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:itemId/embed',
	query: [],
};
